
// @ts-check

import React from "react";

import CampaignList, { getQueryName } from "./CampaignList";

// @ts-ignore
import xIcon from "../images/remove_search.svg";

import FocusTrap from "focus-trap-react"

/**
 * @typedef {import('./coreTypes').CampaignObject} CampaignObject
 */


/**
 * @param {{ 
 *    cancelLightbox: () => void,
 *    selectCampaign: (a: string) => void, }} props 
 * @returns {JSX.Element | null}
 */
function MobileChooseCampaignLightbox(props) {

    const campaignCards = 
        CampaignList.map(c => (
            <>
                <div className="campaign-card__container" tabIndex={ 0 } role={ "link" }
                    onKeyDown={ (event) => {
                        // keyboard support for campaign items
                        if (event.key === "Enter") {
                            props.selectCampaign(getQueryName(c)); 
                            props.cancelLightbox();
                        }
                } } 
                     onClick={() => { 
                        props.selectCampaign(getQueryName(c)); 
                        props.cancelLightbox();
                        }}>
                    <label className="campaign-card__label">{c.title}</label>
                    <img className="campaign-card__image" src={c.image.browse.url} alt={c.title} />
                </div>
                <p style={{ marginTop: 10, }}></p>
            </>
            ));

    
    return (
        <FocusTrap>
        {/** @ts-ignore */}
        <div style={outsideLightboxStyle} onClick={props.cancelLightbox}>
            {/** @ts-ignore */}
            <div style={lightBoxContainerStyle} onClick={e => { e.stopPropagation(); }}>
                <img src={xIcon} style={xButtonStyle} onClick={props.cancelLightbox} alt="Cancel" />
                <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <div className="campaign-card-list__section">
                        <h2 className="campaign-card-list__title">Browse By Campaign</h2>
                        <div className="campaign-card-list__container">
                            {campaignCards}
                        </div>
                    </div>
                </div>
            </div>      
        </div>
        </FocusTrap>
    );
}

const outsideLightboxStyle = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.8)',
    zIndex: '10',
    overflowY: 'scroll',
};

const lightBoxContainerStyle = {
    width: '80%',
    backgroundColor: 'white',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 20,
    fontColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 300,
    textAlign: 'center',
};

const xButtonStyle = {
    margin: 10,
    padding: 4,
    width: 30,
    alignSelf: 'end',
    cursor: 'pointer',
};


export default MobileChooseCampaignLightbox;

